import { useState, useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Switch } from '../../components/ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';

const EMPTY = { name: '', fee: '', free_over_m2: '', suburbs: '', postcodes: '', notes: '', active: true };
const splitList = (s) => s.split(/[\n,]/).map((x) => x.trim()).filter(Boolean);

export function DeliveryZoneFormDialog({ open, onOpenChange, zone, onSave }) {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setForm(zone ? { ...EMPTY, ...zone, fee: String(zone.fee), free_over_m2: zone.free_over_m2 == null ? '' : String(zone.free_over_m2), suburbs: (zone.suburbs || []).join('\n'), postcodes: (zone.postcodes || []).join(', '), notes: zone.notes || '' } : EMPTY);
  }, [open, zone]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave({
        name: form.name,
        fee: parseFloat(form.fee) || 0,
        free_over_m2: form.free_over_m2 === '' ? null : parseFloat(form.free_over_m2),
        suburbs: splitList(form.suburbs),
        postcodes: splitList(form.postcodes),
        notes: form.notes || null,
        active: form.active,
      });
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="zone-form-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">{zone ? 'Edit delivery zone' : 'Add delivery zone'}</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2"><Label>Zone name</Label><Input required value={form.name} onChange={set('name')} placeholder="Gold Coast North" data-testid="zone-name-input" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Delivery fee (AUD)</Label><Input required type="number" step="0.01" min="0" value={form.fee} onChange={set('fee')} data-testid="zone-fee-input" /></div>
            <div className="space-y-2"><Label>Free delivery over (m²)</Label><Input type="number" step="1" min="0" value={form.free_over_m2} onChange={set('free_over_m2')} placeholder="Leave blank for none" data-testid="zone-free-input" /></div>
          </div>
          <div className="space-y-2"><Label>Suburbs (one per line or comma separated)</Label><Textarea rows={6} value={form.suburbs} onChange={set('suburbs')} placeholder={'Beaudesert\nTamborine\nCanungra'} data-testid="zone-suburbs-input" /></div>
          <div className="space-y-2"><Label>Postcodes (optional, comma separated)</Label><Input value={form.postcodes} onChange={set('postcodes')} placeholder="4285, 4270" data-testid="zone-postcodes-input" /></div>
          <div className="space-y-2"><Label>Notes shown to customers</Label><Input value={form.notes} onChange={set('notes')} placeholder="Close to the farm" data-testid="zone-notes-input" /></div>
          <label className="flex items-center gap-2 text-sm"><Switch checked={form.active} onCheckedChange={(v) => setForm((f) => ({ ...f, active: v }))} data-testid="zone-active-switch" /> Active (used for quotes)</label>
          <div className="flex gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1">Cancel</Button>
            <Button type="submit" disabled={saving} className="flex-1 btn-primary" data-testid="zone-save-btn">{saving ? 'Saving…' : 'Save zone'}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
